<template>
  <transition name="fadeScale">
    <div class="modalBg" @click="close">
      <div class="modalContent" @click="e => e.stopPropagation()">
        <component :is="modal.name" :payload="modal.payload" @close-modal="close" />
      </div>
    </div>
  </transition>
</template>

<script>
const PurchaseModal = defineAsyncComponent(() => import('@/components/modals/PurchaseModal.vue'))
const StageTicketWarningModal = defineAsyncComponent(() => import('@/components/modals/StageTicketWarningModal.vue'))
const FreepassModal = defineAsyncComponent(() => import('@/components/modals/FreepassModal.vue'))
const CalendarModal = defineAsyncComponent(() => import('@/components/modals/CalendarModal.vue'))
const AreaSelectModal = defineAsyncComponent(() => import('@/components/modals/AreaSelectModal.vue'))
const SendTicketModal = defineAsyncComponent(() => import('@/components/modals/SendTicketModal.vue'))
const PlanedAreaModal = defineAsyncComponent(() => import('@/components/modals/PlanedAreaModal.vue'))
const PurchaseRequirementModal = defineAsyncComponent(() => import('@/components/modals/PurchaseRequirementModal.vue'))
const KonkatsuFreepassRefundModal = defineAsyncComponent(() => import('@/components/modals/KonkatsuFreepassRefundModal.vue'))
const BookmarkEventsNotificationModal = defineAsyncComponent(() => import('@/components/modals/BookmarkEventsNotificationModal.vue'))
const RecommendFreepassModal = defineAsyncComponent(() => import('@/components/modals/RecommendFreepassModal.vue'))
const ShareSnsModal = defineAsyncComponent(() => import('@/components/modals/ShareSnsModal.vue'))
const QuestionnaireRemindModal = defineAsyncComponent(() => import('@/components/modals/QuestionnaireRemindModal.vue'))
const ClEventsInfoModal = defineAsyncComponent(() => import('@/components/modals/ClEventsInfoModal.vue'))
const CautionTextModal = defineAsyncComponent(() => import('@/components/modals/CautionTextModal.vue'))
export default {
  components: {
    PurchaseModal,
    StageTicketWarningModal,
    FreepassModal,
    CalendarModal,
    AreaSelectModal,
    SendTicketModal,
    PlanedAreaModal,
    PurchaseRequirementModal,
    KonkatsuFreepassRefundModal,
    BookmarkEventsNotificationModal,
    RecommendFreepassModal,
    ShareSnsModal,
    QuestionnaireRemindModal,
    ClEventsInfoModal,
    CautionTextModal
  },
  computed: {
    modal() {
      return this.$store.$state.modal
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden'
  },
  beforeUnmount() {
    document.body.style.overflow = ''
  },
  methods: {
    close() {
      if (this.$store.$state.modal.name === 'QuestionnaireRemindModal') {
        const query = { code: this.$store.$state.modal.payload.questionnaire_code }
        this.$store.dispatch('noNeedRemind', query)
      }
      this.$store.MODAL(null)
    }
  }
}
</script>

<style lang="scss" scoped>
.modalBg {
  @include flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 2rem;
  background: $black-05;
}
</style>
